import { matchPath } from 'react-router-dom';

export const RUM_SURFACE_SCOPE = 'mui_web';

const ROUTE_CONTEXTS = [
  { path: '/mspHome/administration/cloud-rest-api', featureKey: 'msp.administration.cloud_rest_api', scope: 'msp' },
  { path: '/mspHome/administration/manage-subscriptions', featureKey: 'msp.administration.manage_subscriptions', scope: 'msp' },
  { path: '/mspHome/administration/lmsSubscriptions', featureKey: 'msp.administration.lms_subscriptions', scope: 'msp' },
  { path: '/mspHome/administration/reports', featureKey: 'msp.administration.reports', scope: 'msp' },
  { path: '/mspHome/administration/users', featureKey: 'msp.administration.users', scope: 'msp' },
  { path: '/mspHome/administration', featureKey: 'msp.administration', scope: 'msp' },
  { path: '/mspHome/dashboard', featureKey: 'msp.dashboard', scope: 'msp' },
  { path: '/mspHome/devices', featureKey: 'msp.devices', scope: 'msp' },
  { path: '/mspHome/locations', featureKey: 'msp.locations', scope: 'msp' },
  { path: '/mspHome/notifications', featureKey: 'msp.alarms', scope: 'msp' },
  { path: '/mspHome/organizations', featureKey: 'msp.organizations', scope: 'msp' },
  { path: '/mspHome/topology', featureKey: 'location.topology', scope: 'location' },
  {
    path: '/organization/:orgName/administration/cloud-rest-api',
    featureKey: 'organization.administration.cloud_rest_api',
    scope: 'organization'
  },
  { path: '/organization/:orgName/administration/policy', featureKey: 'organization.administration.policy', scope: 'organization' },
  { path: '/organization/:orgName/administration/reports', featureKey: 'organization.administration.reports', scope: 'organization' },
  {
    path: '/organization/:orgName/administration/scheduled-reboot',
    featureKey: 'organization.administration.scheduled_reboot',
    scope: 'organization'
  },
  { path: '/organization/:orgName/administration/users', featureKey: 'organization.administration.users', scope: 'organization' },
  { path: '/organization/:orgName/administration', featureKey: 'organization.administration', scope: 'organization' },
  { path: '/organization/:orgName/clients', featureKey: 'organization.clients', scope: 'organization' },
  { path: '/organization/:orgName/dashboard/map', featureKey: 'organization.dashboard.map', scope: 'organization' },
  { path: '/organization/:orgName/dashboard', featureKey: 'organization.dashboard', scope: 'organization' },
  { path: '/organization/:orgName/device-Groups', featureKey: 'organization.device_groups', scope: 'organization' },
  { path: '/organization/:orgName/devices', featureKey: 'organization.devices', scope: 'organization' },
  { path: '/organization/:orgName/locations', featureKey: 'organization.locations', scope: 'organization' },
  { path: '/organization/:orgName/notifications', featureKey: 'organization.alarms', scope: 'organization' },
  { path: '/organization/:orgName/scheduled', featureKey: 'organization.schedules', scope: 'organization' },
  { path: '/organization/:orgName/security-center', featureKey: 'organization.security_center', scope: 'organization' },
  { path: '/organization/:orgName/SSID', featureKey: 'organization.wifi.ssid', scope: 'organization' },
  { path: '/dashboard/floor-map/:floorId', featureKey: 'location.floor_map', scope: 'location' },
  { path: '/dashboard/floor-map', featureKey: 'location.floor_map', scope: 'location' },
  { path: '/dashboard/map', featureKey: 'location.dashboard.map', scope: 'location' },
  { path: '/dashboard/topology', featureKey: 'location.topology', scope: 'location' },
  { path: '/dashboard', featureKey: 'location.dashboard', scope: 'location' },
  { path: '/Wi-Fi/Advance/FastRoaming', featureKey: 'location.wifi.advance.fast_roaming', scope: 'location' },
  { path: '/Wi-Fi/Advance/MeshNetworkSettings', featureKey: 'location.wifi.advance.mesh_network_settings', scope: 'location' },
  { path: '/Wi-Fi/Advance/MultiPSKSettings', featureKey: 'location.wifi.advance.multi_psk_settings', scope: 'location' },
  { path: '/Wi-Fi/Advance/Network-Settings', featureKey: 'location.wifi.advance.network_settings', scope: 'location' },
  { path: '/Wi-Fi/Advance/Network-Settings', featureKey: 'location.wifi.advance.network_settings', scope: 'location' },
  { path: '/Wi-Fi/Advance/TrafficPolicies', featureKey: 'location.wifi.advance.traffic_policies', scope: 'location' },
  { path: '/Wi-Fi/Advance/URLFiltering', featureKey: 'location.wifi.advance.url_filtering', scope: 'location' },
  { path: '/Wi-Fi/Advance/WirelessSettings', featureKey: 'location.wifi.advance.wireless_settings', scope: 'location' },
  { path: '/Wi-Fi/instantWiFi', featureKey: 'location.wifi.instant_wifi', scope: 'location' },
  { path: '/Wi-Fi/LoadBalancing', featureKey: 'location.wifi.load_balancing', scope: 'location' },
  { path: '/Wi-Fi/ManagementVLAN', featureKey: 'location.wifi.management_vlan', scope: 'location' },
  { path: '/Wi-Fi/Profiles', featureKey: 'location.wifi.profiles', scope: 'location' },
  { path: '/Wi-Fi/schedules', featureKey: 'location.wifi.schedules', scope: 'location' },
  { path: '/Wi-Fi/SSID', featureKey: 'location.wifi.ssid', scope: 'location' },
  { path: '/Wi-Fi', featureKey: 'location.wifi.overview', scope: 'location' },
  { path: '/MobileHotspot', featureKey: 'location.mobile_hotspot', scope: 'location' },
  { path: '/MobileProfile', featureKey: 'location.mobile_profiles', scope: 'location' },
  { path: '/MobileProfile/geofence', featureKey: 'location.mobile_profiles.geofence', scope: 'location' },
  { path: '/MobileProfile/mobile-profiles', featureKey: 'location.mobile_profiles', scope: 'location' },
  { path: '/locationDevice/stack/:stackId/:tab', featureKey: 'location.wired.stack', scope: 'location' },
  { path: '/locationDevice/stack/:stackId', featureKey: 'location.wired.stack', scope: 'location' },
  { path: '/locationDevice/orbi/*', featureKey: 'location.devices.orbi', scope: 'location' },
  { path: '/locationDevice', featureKey: 'location.devices', scope: 'location' },
  { path: '/locationSettings/configBackup', featureKey: 'location.settings.config_backup', scope: 'location' },
  { path: '/locationSettings/device-Groups', featureKey: 'location.settings.device_groups', scope: 'location' },
  { path: '/locationSettings/firmware/:tabId', featureKey: 'location.settings.firmware', scope: 'location' },
  { path: '/locationSettings/firmware', featureKey: 'location.settings.firmware', scope: 'location' },
  { path: '/locationSettings/general', featureKey: 'location.settings.general', scope: 'location' },
  { path: '/locationSettings/LED-Settings', featureKey: 'location.settings.led', scope: 'location' },
  { path: '/locationSettings/mdnsGateway', featureKey: 'location.settings.mdns_gateway', scope: 'location' },
  { path: '/locationSettings/radius', featureKey: 'location.settings.radius', scope: 'location' },
  { path: '/locationSettings/routing', featureKey: 'location.settings.routing', scope: 'location' },
  { path: '/locationSettings/snmp', featureKey: 'location.settings.snmp', scope: 'location' },
  { path: '/locationSettings/Syslog', featureKey: 'location.settings.syslog', scope: 'location' },
  { path: '/locationSettings/VLAN', featureKey: 'location.settings.vlan', scope: 'location' },
  { path: '/locationSettings', featureKey: 'location.settings', scope: 'location' },
  { path: '/clients', featureKey: 'location.clients', scope: 'location' },
  { path: '/dynamicDns', featureKey: 'location.dynamic_dns', scope: 'location' },
  { path: '/events', featureKey: 'location.events', scope: 'location' },
  { path: '/notifications', featureKey: 'location.notifications', scope: 'location' },
  { path: '/scheduled', featureKey: 'location.schedules', scope: 'location' },
  { path: '/security-center', featureKey: 'location.security_center', scope: 'location' },
  { path: '/wired/dhcpRelay', featureKey: 'location.wired.dhcp_relay', scope: 'location' },
  { path: '/wired/dhcpSnooping', featureKey: 'location.wired.dhcp_snooping', scope: 'location' },
  { path: '/wired/lag', featureKey: 'location.wired.lag', scope: 'location' },
  { path: '/wired/managementVlan', featureKey: 'location.wired.management_vlan', scope: 'location' },
  { path: '/wired/PoESchedules', featureKey: 'location.wired.poe_schedules', scope: 'location' },
  { path: '/wired/radiusConfiguration', featureKey: 'location.wired.radius_configuration', scope: 'location' },
  { path: '/wired/spanningTree', featureKey: 'location.wired.spanning_tree', scope: 'location' },
  { path: '/wired/VLAN', featureKey: 'location.wired.vlan', scope: 'location' },
  { path: '/wired', featureKey: 'location.wired.overview', scope: 'location' },
  { path: '/device-group/devices', featureKey: 'device_group.devices', scope: 'device_group' },
  { path: '/device-group/settings', featureKey: 'device_group.settings', scope: 'device_group' },
  { path: '/device-group/wireless/Advance/FastRoaming', featureKey: 'device_group.wifi.advance.fast_roaming', scope: 'device_group' },
  {
    path: '/device-group/wireless/Advance/MultiPSKSettings',
    featureKey: 'device_group.wifi.advance.multi_psk_settings',
    scope: 'device_group'
  },
  {
    path: '/device-group/wireless/Advance/Network-Settings',
    featureKey: 'device_group.wifi.advance.network_settings',
    scope: 'device_group'
  },
  {
    path: '/device-group/wireless/Advance/WirelessSettings',
    featureKey: 'device_group.wifi.advance.wireless_settings',
    scope: 'device_group'
  },
  { path: '/device-group/wireless/instantWiFi', featureKey: 'device_group.wifi.instant_wifi', scope: 'device_group' },
  { path: '/device-group/wireless/LoadBalancing', featureKey: 'device_group.wifi.load_balancing', scope: 'device_group' },
  { path: '/device-group/wireless/ManagementVLAN', featureKey: 'device_group.wifi.management_vlan', scope: 'device_group' },
  { path: '/device-group/wireless/schedules', featureKey: 'device_group.wifi.schedules', scope: 'device_group' },
  { path: '/device-group/wireless/SSID', featureKey: 'device_group.wifi.ssid', scope: 'device_group' },
  { path: '/device-group/wired/vlan', featureKey: 'device_group.wired.vlan', scope: 'device_group' },
  { path: '/devices/AP/alarms', featureKey: 'device.ap.alarms', scope: 'device' },
  { path: '/devices/AP/clients', featureKey: 'device.ap.clients', scope: 'device' },
  { path: '/devices/AP/configuration', featureKey: 'device.ap.configuration', scope: 'device' },
  { path: '/devices/AP/mesh', featureKey: 'device.ap.mesh', scope: 'device' },
  { path: '/devices/AP/neighboring-ap', featureKey: 'device.ap.neighboring_ap', scope: 'device' },
  { path: '/devices/AP/summary', featureKey: 'device.ap.summary', scope: 'device' },
  { path: '/devices/AP/troubleshoot', featureKey: 'device.ap.troubleshoot', scope: 'device' },
  { path: '/devices/MHS/alarms', featureKey: 'device.mhs.alarms', scope: 'device' },
  { path: '/devices/MHS/clients', featureKey: 'device.mhs.clients', scope: 'device' },
  { path: '/devices/MHS/connected-clients', featureKey: 'device.mhs.connected_clients', scope: 'device' },
  { path: '/devices/MHS/ip-settings', featureKey: 'device.mhs.ip_settings', scope: 'device' },
  { path: '/devices/MHS/restore-and-backup', featureKey: 'device.mhs.restore_and_backup', scope: 'device' },
  { path: '/devices/MHS/settings', featureKey: 'device.mhs.settings', scope: 'device' },
  { path: '/devices/MHS/summary', featureKey: 'device.mhs.summary', scope: 'device' },
  { path: '/devices/MHS/troubleshoot', featureKey: 'device.mhs.troubleshoot', scope: 'device' },
  {
    path: '/devices/:deviceType/:tab',
    featureKey: ({ deviceType, tab }) => `device.${sanitizeFeatureToken(deviceType)}.${sanitizeFeatureToken(tab)}`,
    scope: 'device'
  },
  { path: '/devices', featureKey: 'location.devices', scope: 'location' },
  { path: '/support/usersList', featureKey: 'support.users_list', scope: 'support' },
  { path: '/user-profile/change-email', featureKey: 'user_profile.change_email', scope: 'account' },
  { path: '/user-profile/change-password', featureKey: 'user_profile.change_password', scope: 'account' },
  { path: '/user-profile/edit', featureKey: 'user_profile.edit', scope: 'account' },
  { path: '/user-profile/login-settings', featureKey: 'user_profile.login_settings', scope: 'account' },
  { path: '/user-profile', featureKey: 'user_profile.overview', scope: 'account' },
  { path: '/newLogin', featureKey: 'onboarding.new_login', scope: 'account' },
  { path: '/', featureKey: 'root', scope: 'account' }
];

function getBasename() {
  return String(import.meta.env.VITE_APP_BASE_NAME || '').replace(/\/$/, '');
}

function stripBasename(pathname) {
  const basename = getBasename();
  let nextPath = pathname || '/';

  if (basename && (nextPath === basename || nextPath.startsWith(`${basename}/`))) {
    nextPath = nextPath.slice(basename.length) || '/';
  }

  if (!nextPath.startsWith('/')) {
    nextPath = `/${nextPath}`;
  }

  return nextPath;
}

function sanitizePathSegment(value) {
  return String(value || '')
    .trim()
    .replace(/\/+/g, '')
    .replace(/\s+/g, '-')
    .replace(/[^A-Za-z0-9._:-]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

function sanitizeFeatureToken(value) {
  return sanitizePathSegment(value)
    .replace(/[.:/-]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')
    .toLowerCase();
}

function looksDynamicSegment(segment) {
  if (!segment) return false;
  return /^[0-9]{5,}$/.test(segment) || /^[0-9a-f]{16,}$/i.test(segment) || /^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(segment);
}

function inferScope(pathname) {
  if (pathname.startsWith('/mspHome/')) return 'msp';
  if (pathname.startsWith('/organization/')) return 'organization';
  if (pathname.startsWith('/devices/')) return 'device';
  if (pathname.startsWith('/device-group/')) return 'device_group';
  if (pathname.startsWith('/support/')) return 'support';
  if (pathname.startsWith('/user-profile')) return 'account';
  return 'location';
}

function buildFallbackTemplate(pathname) {
  const segments = stripBasename(pathname).split('/').filter(Boolean);

  if (!segments.length) return '/';

  if (segments[0] === 'organization' && segments[1]) {
    segments[1] = ':orgName';
  }
  if (segments[0] === 'dashboard' && segments[1] === 'floor-map' && segments[2]) {
    segments[2] = ':floorId';
  }
  if (segments[0] === 'locationDevice' && segments[1] === 'stack' && segments[2]) {
    segments[2] = ':stackId';
  }
  if (segments[0] === 'devices' && segments[1] && segments[2]) {
    segments[1] = sanitizePathSegment(segments[1]);
    segments[2] = sanitizePathSegment(segments[2]);
  }

  const normalized = segments.map((segment, index) => {
    if (segment.startsWith(':')) return segment;
    if (index > 0 && looksDynamicSegment(segment)) return ':param';
    return sanitizePathSegment(segment);
  });

  return `/${normalized.join('/')}`;
}

function buildFallbackFeatureKey(routeTemplate, scope) {
  const tokens = routeTemplate
    .split('/')
    .filter(Boolean)
    .filter((token) => !token.startsWith(':'))
    .map(sanitizeFeatureToken)
    .filter(Boolean);

  if (!tokens.length) return scope === 'account' ? 'root' : `${scope}.root`;

  const joined = tokens.join('.');
  return joined.startsWith(`${scope}.`) ? joined : `${scope}.${joined}`;
}

function resolveMappedContext(pathname) {
  for (const routeContext of ROUTE_CONTEXTS) {
    const match = matchPath({ path: routeContext.path, end: true }, pathname);
    if (!match) continue;

    return {
      pageId: routeContext.path,
      featureKey: typeof routeContext.featureKey === 'function' ? routeContext.featureKey(match.params || {}) : routeContext.featureKey,
      scope: routeContext.scope
    };
  }

  return null;
}

export function getRumRouteContext(pathname) {
  const normalizedPathname = stripBasename(pathname);
  const mappedContext = resolveMappedContext(normalizedPathname);

  if (mappedContext) {
    return mappedContext;
  }

  const scope = inferScope(normalizedPathname);
  const pageId = buildFallbackTemplate(normalizedPathname);

  return {
    pageId,
    featureKey: buildFallbackFeatureKey(pageId, scope),
    scope
  };
}

export function getRumPageTags(pathname) {
  const { featureKey, scope } = getRumRouteContext(pathname);
  return [`surface:${RUM_SURFACE_SCOPE}`, `scope:${scope}`, `feature:${featureKey}`];
}

export function getRumPageViewPayload(pathname) {
  const context = getRumRouteContext(pathname);

  return {
    pageId: context.pageId,
    pageTags: getRumPageTags(pathname),
    pageAttributes: {
      page_key: context.pageId,
      feature_key: context.featureKey,
      scope: context.scope,
      surface_scope: RUM_SURFACE_SCOPE
    }
  };
}

export function getRumPageKey(pathname) {
  return getRumRouteContext(pathname).pageId;
}

export function getRumFeatureKey(pathname) {
  return getRumRouteContext(pathname).featureKey;
}

/**
 * RUM pageId is a stable route template with basename stripped and no query string.
 */
export function rumPageIdFromWindow() {
  if (typeof window === 'undefined') return '/';
  return getRumPageKey(window.location.pathname || '/');
}
